import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Virusom je tezko",
  "description": "",
  "published": "2007-02-03T00:00:00.000Z",
  "redirect_from": ["/blog/virusom-je-tezko/swizec/294"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Vas je kdaj zanimalo kako tezko je pravzaprav biti virus, ki zeli pokoncati svet? Sedaj lahko `}<a parentName="p" {...{
        "href": "http://www.newgrounds.com/portal/view/360724"
      }}>{`izveste`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      